// Centralized hero / editorial image URLs used across marketing pages.
// These are curated stock photos (per client request) — swap any URL here
// once real LXRA Studios photography/video assets are available. No other
// code changes are required.

export const SITE_IMAGES = {
  homeHero: 'https://images.unsplash.com/photo-1617901883714-151853555aa8?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80',
  homeAboutPreview: 'https://images.unsplash.com/photo-1555528182-fb968eb34abb?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80',
  galleriesHero: 'https://images.unsplash.com/photo-1768481599405-b90d6f8a2fbd?crop=entropy&cs=srgb&fm=jpg&w=2000&q=80',
  servicesHero: 'https://images.unsplash.com/photo-1743463685519-469d9ebe1b7f?crop=entropy&cs=srgb&fm=jpg&w=2000&q=80',
  aboutHero: 'https://images.unsplash.com/photo-1632235797862-3644acd554e6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80',
  contactBackground: 'https://images.unsplash.com/photo-1696270804579-2611eab08bb5?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80',
};

// Curated free-license (Mixkit) cinematic background videos used as animated
// hero backdrops. Poster images fall back to SITE_IMAGES entries above while
// the clip loads, and on reduced-motion / autoplay-blocked browsers.
export const SITE_VIDEOS = {
  homeHero: 'https://assets.mixkit.co/videos/42343/42343-360.mp4',
  servicesHero: 'https://assets.mixkit.co/videos/50635/50635-360.mp4',
  homeAboutPreview: 'https://assets.mixkit.co/videos/50646/50646-360.mp4',
  galleriesHero: 'https://assets.mixkit.co/videos/48529/48529-360.mp4',
  aboutHero: 'https://assets.mixkit.co/videos/44074/44074-360.mp4',
  contactBackground: 'https://assets.mixkit.co/videos/41375/41375-360.mp4',
  showreel: 'https://assets.mixkit.co/videos/52427/52427-360.mp4',
};

// NOTE: Static curated placeholder grid for the "Follow the Story" Instagram
// strip on Home — not a live-syncing feed (would require Instagram Graph API
// + app review with the studio's own Instagram Business account).
export const INSTAGRAM_STRIP_IMAGES = [
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
  'https://images.unsplash.com/photo-1563170446-9c3c0622d8a9?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
  'https://images.unsplash.com/photo-1637479457230-7e09c10e37a6?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
  'https://images.unsplash.com/photo-1558507652-2d9626c4e67a?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
  'https://images.unsplash.com/photo-1628890954311-74476fcbf0d4?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
  'https://images.unsplash.com/photo-1674932668403-33398b81c92f?crop=entropy&cs=srgb&fm=jpg&w=600&q=80',
];

// Rotating hero backdrop for the homepage — several curated, free-license
// (Mixkit) cinematic clips that crossfade in sequence, each representing a
// different side of the business (portraits, automotive, weddings/events,
// studio sessions). Swap/reorder freely; the rotator just cycles the array.
export const HOME_HERO_VIDEOS = [
  { key: 'portraits', label: 'Portraits', src: SITE_VIDEOS.homeHero, poster: SITE_IMAGES.homeHero },
  { key: 'automotive', label: 'Automotive', src: 'https://assets.mixkit.co/videos/3124/3124-360.mp4', poster: SITE_IMAGES.homeHero },
  { key: 'weddings', label: 'Weddings & Events', src: 'https://assets.mixkit.co/videos/5204/5204-360.mp4', poster: SITE_IMAGES.homeHero },
  { key: 'studio', label: 'Studio Sessions', src: 'https://assets.mixkit.co/videos/50647/50647-360.mp4', poster: SITE_IMAGES.homeHero },
];
